import { Component, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticatorSetupModalComponent } from '../../shared/components/two-factor-auth/authenticator-setup-modal/authenticator-setup-modal.component';

@Component({
    selector: 'app-authenticator-register',
    standalone: true,
    imports: [AuthenticatorSetupModalComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        :host {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            background: var(--stela-aubergine);
        }
    `],
    template: `
        <authenticator-setup-modal
            [visible]="modalVisible()"
            [token]="token()"
            (visibleChange)="onVisibleChange($event)"
            (registered)="onRegistered()" />
    `
})
export class AuthenticatorRegisterComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);

    readonly modalVisible = signal(false);
    readonly token = signal('');

    ngOnInit(): void {
        this.token.set(this.route.snapshot.params['token'] || '');
        this.modalVisible.set(true);
    }

    onVisibleChange(visible: boolean): void {
        if (!visible) {
            this.router.navigate(['/auth/init']);
        }
    }

    onRegistered(): void {
        this.router.navigate(['/auth/init']);
    }
}
